<template>
  <bm-control v-bind="$attrs" :read-only-value="formattedDate">
    <template #default="{ dataQa }">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template #activator="{ on }">
          <v-text-field
            :value="formattedDate"
            class="bm-text"
            :placeholder="placeholderVal"
            prepend-icon="event"
            readonly
            v-bind="$attrs"
            :clearable="clearable"
            color="brand02"
            :label="undefined"
            :data-qa="dataQa"
            v-on="on"
            @input="textFieldChanged"
          >
          </v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          no-title
          scrollable
          color="brand02"
          :events="events"
          :data-qa="`${dataQa}_picker`"
          :first-day-of-week="startDayOfWeek"
          @input="menu = false"
        >
        </v-date-picker>
      </v-menu>
    </template>
  </bm-control>
</template>

<script lang="ts">
import BmControl from "@/components/controls/input/BmControl.vue";
import { LocalDate } from "@js-joda/core";
import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import type { PropType } from "vue";
import { defineComponent } from "vue";
import userStore from "@/store/modules/userStore";
export default defineComponent({
  name: "BmDate",
  components: { BmControl },
  inheritAttrs: false,
  props: {
    value: {
      type: Object as PropType<LocalDate | null>,
      required: false,
      default: () => null,
    },
    placeholder: {
      type: String,
      required: false,
    },
    clearable: {
      type: Boolean,
      required: false,
    },
    events: {
      type: Function as PropType<
        (item: any) => string | boolean | string[] | boolean[]
      >,
      default: () => [],
    },
  },
  data() {
    return {
      menu: false,
      date: "" as string | null,
    };
  },
  computed: {
    placeholderVal(): string {
      if (!this.placeholder) {
        return " ";
      }

      return this.placeholder;
    },
    formattedDate(): string {
      if (!this.date) {
        return "";
      }

      // Use the tenants date formatter to show the ISO 8601 date in a preferable format.
      return tenantService.formatDate(LocalDate.parse(this.date));
    },
    startDayOfWeek(): Number {
      return userStore.state.user?.calendarStartDay.key ?? 1;
    },
  },
  watch: {
    value: {
      // @ts-ignore
      handler: "valueWatch",
      immediate: true,
    },
    date: {
      // @ts-ignore
      handler: "dateWatch",
    },
  },
  methods: {
    valueWatch(val: LocalDate) {
      this.date = val ? val.toString() : null;
    },
    textFieldChanged(val: string | null) {
      // ensure we clear the date if the value is cleared via the textbox
      if (val === null) {
        this.date = null;
      }
    },
    dateWatch(val: string) {
      if (val == null) {
        this.$emit("input", null);
      } else {
        this.$emit("input", LocalDate.parse(val));
      }
    },
  },
});
</script>

<style scoped lang="sass">
@import "src/sass/typography"

.bm-text
  @include bm-field
</style>
